import { Text } from '@savvy-kit/foundations/text';
import { X } from 'lucide-react';

type Props = {
  readonly label: string;
  readonly onClear: () => void;
  readonly values: string[];
};

export function ActiveFilter(props: Props) {
  const { label, values, onClear } = props;

  return (
    <div className="flex flex-row items-center border border-border-light rounded">
      <Text
        variant="body-sm"
        color="dark"
        className="my-2 border-r border-light px-2.5 normal-case tracking-normal font-medium"
      >
        {label}
      </Text>
      <Text variant="body-sm" color="dark" className="my-2 px-2.5 normal-case tracking-normal font-medium">
        {values.join(', ')}
      </Text>
      <div onClick={onClear} className="px-2 pt-[7px] border-l border-border-light cursor-pointer h-full">
        <X style={{ color: 'var(--savvy-neutral-600)' }} />
      </div>
    </div>
  );
}
